import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'log-process',
  templateUrl: './log-process.component.html',
  styleUrls: ['./log-process.component.less']
})
export class LogProcessComponent implements OnInit {
  @Input() status: any; 
  @Input() deliveryList: any; 
  deliveryStatus=["delivery created","Picking started","Picking Complete","Packing Complete","Post Goods Issue","Collected","In Transit","In delivery","Delivered"];
  iconList=["delivery-created","picking-started","picking-completed-real","packing-completed","issue-posted","picked-up","in-transit","out-for-delivery","out-for-delivery","delivered"];
  statusList:any[]=[];
  constructor() { }

  ngOnInit(): void {
    if(this.deliveryList===""){
      this.deliveryList=[];
    }
    this.statusList = this.deliveryStatus.map((status, index) => {
      const matchingDelivery = this.deliveryList.find((delivery:any) => delivery.statusInfo === status);
      let time = "";
      if (matchingDelivery) {
          time = matchingDelivery.noticeTime;
      }
      return {
          title: status, 
          icon: time===""?this.iconList[index]+'_grey':this.iconList[index], 
          time: time,
          isActive:time!=="",
          isStatus:this.status == status
      };
    });
  }
}
